<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import CloseButton from '@/components/common/button/CloseButton.vue';

const store = useStore();
const toasts = computed(() => store.getters['toast/getToasts']);

const removeToast = (id) => {
  store.commit('toast/removeToast', id);
};

</script>

<template>
  <div class="notification_toast">
    <TransitionGroup name="fade">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="notification_toast_card"
      >
        <div
          class="notification_toast_icon"
          :class="toast.className"
        >
          <i
            class="notification_toast_icon_inner icon"
            :class="toast.icon"
          />
        </div>
        <div class="notification_toast_group">
          <div class="notification_toast_title">
            {{ toast.title }}
          </div>
          <div class="notification_toast_content">
            {{ toast.text }}
          </div>
        </div>
        <div class="notification_toast_button">
          <close-button @click="removeToast(toast.id)" />
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped lang="scss">
@use "~/_variables" as variables;

.notification_toast {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: variables.$z-index_toast;
  width: 300px;
  background: transparent;
  pointer-events: none;
}
.notification_toast_card {
  pointer-events: auto;
  position: relative;
  padding: 14px 26px 14px 13px;
  background-color: variables.$white;
  border: 1px solid variables.$border_gray_200;
  box-shadow: 0 4px 8px 0 variables.$shadow_gray_200;
  display: flex;
  & ~ .notification_toast_card {
    margin-top: 20px;
  }
}
.notification_toast_group {
  margin-left: 13px;
  word-wrap: break-word;
  flex: 1;
}
.notification_toast_title {
  color: variables.$text_normal;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.notification_toast_content {
  color: variables.$text_normal;
  font-size: 14px;
  line-height: variables.$line_height_base;
}
.notification_toast_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  box-sizing: border-box;
  &.notification_toast_icon_success {
    background-color: variables.$green;
  }
  &.notification_toast_icon_error {
    background-color: variables.$attention;
  }
}
.notification_toast_icon_inner {
  font-size: 10px;
  color: variables.$white;
}
.notification_toast_button {
  position: absolute;
  top: 10px;
  right: 12px;
  flex-shrink: 0;
  color: variables.$text_sub;
}

.fade-enter-active {
  transition: all 0.5s ease;
  transform: translateX(0);
}
.fade-leave-active {
  transition: all 0.3s linear;
  transform: translateX(0);
}

.fade-enter-from,
.fade-leave-to {
  transform: translateX(400px);
}
</style>
